module.exports = __webpack_public_path__ + "fonts/firacode-bold.d9b0648.woff2";